import { Skeleton } from '@mui/material'

const WalletIcon = ({
  provider,
  width = 30,
  height = 30,
  icon,
}: {
  provider: string
  width?: number
  height?: number
  icon?: string
}) => {
  const getImageSrc = (icon: string) => {
    if (icon.startsWith('data:')) return icon

    if (icon.startsWith('http://') || icon.startsWith('https://')) return icon

    if (icon.includes('<svg') || icon.includes('<SVG')) return `data:image/svg+xml;utf8,${encodeURIComponent(icon)}`

    return `data:image/svg+xml;utf8,${encodeURIComponent(icon)}`
  }

  return icon ? (
    <img width={width} height={height} src={getImageSrc(icon)} alt={`${provider} logo`} />
  ) : (
    <Skeleton variant="circular" width={width} height={height} />
  )
}

export default WalletIcon
